<template>
  <div :class="$style.box" v-if="!hideAll">
    <div :class="$style.dialog" v-if="!isPc">
      <div>
        <p :class="$style.turn">因游戏更新，微信小程序限制较多，邀您升级客户端版本畅玩游戏</p>
        <p :class="$style.turn">即刻下载5M客户端版本，领取升级大礼包~</p>
        <p :class="$style.turn">您可在客户端上正常游戏和支付~</p>
        <div :class="$style.pass">
          <div>
            <p>
              您的游戏账号为：<span>{{ userInfo.user_name || user_name }}</span>
            </p>
            <p>
              您的游戏密码为：<span>{{ userInfo.password || '******' }}</span>
            </p>
          </div>
          <Button
            :class="[$style.copyBtn, 'copyBtn']"
            :data-clipboard-text="copyText"
          >一键复制</Button>
        </div>
        <p :class="$style.turn"></p>
        <p :class="$style.turn">您可以“一键复制”，在<span :class="$style.bold">输入框中长按进行粘贴</span></p>
        <p :class="$style.turn">（链接<span :class="$style.bold">生效时间有限</span>，请尽快保存）</p>
        <img :src="dialogBg" alt="" />
      </div>
    </div>
    <div :class="$style.pc">
      <div :class="$style.pcdialog">
        <p  :class="$style.turn">
          <span :class="$style.stroken">因游戏更新，微信小程序限制较多，邀您升级客户端版本畅玩游戏</span>
          <span :class="$style.text">因游戏更新，微信小程序限制较多，邀您升级客户端版本畅玩游戏</span>
        </p>
        <p  :class="$style.turn">
          <span :class="$style.stroken">即刻手机扫码下载5M客户端版本，领取升级大礼包</span>
          <span :class="$style.text">即刻手机扫码下载5M客户端版本，领取升级大礼包</span>
        </p>
        <p :class="$style.turn1">您可在手机上正常游戏和支付</p>
        <div :class="$style.pass">
          <div>
            <p>
              您的账号为：<span>{{ userInfo.user_name || user_name }}</span>
            </p>
            <p>
              您的密码为：<span>{{ userInfo.password || '******' }}</span>
            </p>
          </div>
        </div>
        <div :class="$style.qrcode">
          <p>扫码下载</p>
          <img :src="qrcodeLink" alt="" v-if="qrVisible">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from '@/config';
import { getURL } from '@/apis/gameJump';
import { mapState } from "vuex";
import Clipboard from "clipboard";
import { Toast } from "vant";
import QRCode from 'qrcode'

export default {
  data() {
    return {
      bg: `${CDN_URL}/wxact/game-bg.png`, // 背景小猫图片
      dialogBg: `${CDN_URL}/wxact/game-open1.png`, // 打开浏览器示意图
      isWX: false, // 是否为微信内置浏览器
      bindPass: '', // 绑定密码 只有初次提交表单回显
      account: '', // 绑定手机号 用于初次提交回显
      apkURL: '', // 游戏下载链接
      user_name: '',
      copyText: '',
      hideAll: false,
      isPc: false,
      qrcodeLink: '',
      qrVisible: false,
    };
  },
  async mounted() {
    const { userName, pc } = this.$route.query;
    this.user_name = userName || '';
    if (pc) this.isPc = true;
    this.isWeiXin();
    this.copyInit();
    setTimeout(() => {
      this.copyText = `您的账号为${this.userInfo.user_name || this.user_name} 您的密码为${this.userInfo.password || ''}`
    }, 18);
  },
  computed: {
    ...mapState("gamejump", {
      userInfo: "userInfo",
    }),
  },
  methods: {
    copyInit() {
      this.copy = new Clipboard(".copyBtn");
      this.copy.on("success", () => {
        Toast("复制成功");
      });
    },
    // 判断是否为微信浏览器
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWX = true;
        if (this.isPc) {
          this.getURL();
        }
        if (!this.userInfo.user_name && !this.user_name) {
          this.hideAll = true;
          document.title = '出错啦！'
          Toast("服务器异常，请联系客服处理");
        }
      } else {
        this.isWX = false;
        if (!this.userInfo.user_name && !this.user_name) {
          this.hideAll = true;
        }
        this.getURL();
      }
    },
    // 非微信浏览器获取下载链接
    async getURL() {
      const { ret, content } = await getURL({
        appkey: this.$route.query.appkey || 0,
        type: this.$route.query.type || '',
      });
      if (ret === 1) {
        if (this.isPc) {
          console.log(129, content.apk_url);
          this.qrcodeLink = await QRCode.toDataURL(content.apk_url);
          this.qrVisible = true;
          console.log(131, this.qrcodeLink)
        } else {
          this.apkURL = content.apk_url;
          window.open(this.apkURL, '_self');
        }
      }
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: auto;
  background-color: #ddac69;
  padding-top: 10px;  
  .dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #ddac69;
    z-index: 4;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #b2b2b2;
    overflow: auto;
    padding-bottom: 20px;
    line-height: 22px;
    > div {
      width: 356px;
      margin: 10px auto 0px auto;
      background-color: #fff;
      border-radius: 8px;
      padding: 14px;
      .turn {
        margin-bottom: 15px;
      }
      p {
        > span {
          color: #cfa668;
        }
        .bold {
          font-weight: bold;
        }
      }
      > img {
        width: 100%;
      }    
      .pass {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @keyframes copyBtn {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
        .copyBtn {
          border: none;
          outline: none;
          background-color: #eecb9d;
          color: #FFFFFF;
          font-size: 14px;
          border-radius: 4px;
          padding: 2px 14px;
          animation: copyBtn .5s infinite linear;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
  .pc {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #000000;
    .pcdialog {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/game_jump/pc_2.png') no-repeat;
      background-size: 100% 100%;
      width: 667px;
      height: 375px;
      text-align: center;
      color: #ffffff;
      padding-top: 43px;
      .turn {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        position: relative;
        margin-bottom: 20px;
        .stroken {
          -webkit-text-stroke: 3px rgba(0,0,0,0.45);
        }
        .text {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          background: linear-gradient(0deg,#f4d26c 2%, #fdf1c8 84%);
          -webkit-background-clip:text; 
          -webkit-text-fill-color:transparent;
          &::before{
            content: attr(text);
            position: absolute;
            color: #000000;
            -webkit-mask: linear-gradient(to top,transparent,black);
          }
        }
      }
      .turn1 {
        color: #000000;
        font-size: 12px;
      }
      .pass {
        margin: 30px 0 30px;
        font-size: 12px;
        p {
          margin-bottom: 10px;
        }
      }
      .qrcode {
        img {
          width: 80px;
          height: 80px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
